import { render } from "./dot.vue?vue&type=template&id=db220500&scoped=true"
import script from "./dot.vue?vue&type=script&lang=js"
export * from "./dot.vue?vue&type=script&lang=js"

import "./dot.vue?vue&type=style&index=0&id=db220500&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db220500"]])

export default __exports__